import { combineReducers } from 'redux-immutable';

import device from './device.duck';

export default combineReducers({
  device
});
